import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyItFailed } from './components/WhyItFailed';
import { UniqueMechanism } from './components/UniqueMechanism';
import { Benefits } from './components/Benefits';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-navy selection:bg-mint selection:text-navy" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <Problem data-id="element-4" />
        <WhyItFailed data-id="element-5" />
        <UniqueMechanism data-id="element-6" />
        <Benefits data-id="element-7" />
        <ForWhom data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Proof data-id="element-10" />
        <OfferBlock data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}